import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Location from '../geom/Location';
import Label from './Label';
import GraphComponent from './GraphComponent';
var Node = /*#__PURE__*/function (_GraphComponent) {
  _inherits(Node, _GraphComponent);
  function Node() {
    var _this;
    _classCallCheck(this, Node);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Node).call(this));
    Node.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(Node, [{
    key: "isIncidentEdgeInResult",
    value: function isIncidentEdgeInResult() {
      for (var it = this.getEdges().getEdges().iterator(); it.hasNext();) {
        var de = it.next();
        if (de.getEdge().isInResult()) return true;
      }
      return false;
    }
  }, {
    key: "isIsolated",
    value: function isIsolated() {
      return this._label.getGeometryCount() === 1;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._coord;
    }
  }, {
    key: "print",
    value: function print(out) {
      out.println('node ' + this._coord + ' lbl: ' + this._label);
    }
  }, {
    key: "computeIM",
    value: function computeIM(im) {}
  }, {
    key: "computeMergedLocation",
    value: function computeMergedLocation(label2, eltIndex) {
      var loc = Location.NONE;
      loc = this._label.getLocation(eltIndex);
      if (!label2.isNull(eltIndex)) {
        var nLoc = label2.getLocation(eltIndex);
        if (loc !== Location.BOUNDARY) loc = nLoc;
      }
      return loc;
    }
  }, {
    key: "setLabel",
    value: function setLabel() {
      if (arguments.length === 2 && Number.isInteger(arguments[1]) && Number.isInteger(arguments[0])) {
        var argIndex = arguments[0],
          onLocation = arguments[1];
        if (this._label === null) this._label = new Label(argIndex, onLocation);else this._label.setLocation(argIndex, onLocation);
      } else {
        return _get(_getPrototypeOf(Node.prototype), "setLabel", this).apply(this, arguments);
      }
    }
  }, {
    key: "getEdges",
    value: function getEdges() {
      return this._edges;
    }
  }, {
    key: "mergeLabel",
    value: function mergeLabel() {
      if (arguments[0] instanceof Node) {
        var n = arguments[0];
        this.mergeLabel(n._label);
      } else if (arguments[0] instanceof Label) {
        var label2 = arguments[0];
        for (var i = 0; i < 2; i++) {
          var loc = this.computeMergedLocation(label2, i);
          var thisLoc = this._label.getLocation(i);
          if (thisLoc === Location.NONE) this._label.setLocation(i, loc);
        }
      }
    }
  }, {
    key: "add",
    value: function add(e) {
      this._edges.insert(e);
      e.setNode(this);
    }
  }, {
    key: "setLabelBoundary",
    value: function setLabelBoundary(argIndex) {
      if (this._label === null) return null;
      var loc = Location.NONE;
      if (this._label !== null) loc = this._label.getLocation(argIndex);
      var newLoc = null;
      switch (loc) {
        case Location.BOUNDARY:
          newLoc = Location.INTERIOR;
          break;
        case Location.INTERIOR:
          newLoc = Location.BOUNDARY;
          break;
        default:
          newLoc = Location.BOUNDARY;
          break;
      }
      this._label.setLocation(argIndex, newLoc);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._coord = null;
      this._edges = null;
      var coord = arguments[0],
        edges = arguments[1];
      this._coord = coord;
      this._edges = edges;
      this._label = new Label(0, Location.NONE);
    }
  }]);
  return Node;
}(GraphComponent);
export { Node as default };